// Note: cache only available to the client
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cache = typeof window !== 'undefined' ? new Map<string, any>() : undefined;

const cacheActions = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  add(listing: any) {
    if (typeof listing === 'object' && typeof listing.maloneLotIdEncoded === 'string') {
      cache?.set(listing.maloneLotIdEncoded, listing);
    }
  },

  get: (maloneLotIdEncoded: string) => cache?.get(maloneLotIdEncoded),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateUserItemType(maloneLotIdEncoded: string, type: any) {
    const listing = cache?.get(maloneLotIdEncoded);
    if (listing?.userItemTypes?.indexOf(type) === -1) {
      listing.userItemTypes.push(type);
      cache?.set(maloneLotIdEncoded, listing);
    }
  },
};

export default cacheActions;
